import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { OfferTitleCellComponent } from '../offer-title-cell/offer-title-cell.component';

export const titleColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Title,
  label: injectTranslate()('app.offers.table.title'),
  visible: true,
  geometry: {
    width: 300,
    minWidth: 200,
    autoFitProp: 'width',
  },
  options: {
    draggable: true,
    resizable: true,
    removable: false,
    sortable: false,
  },
  componentFactory: ({ row }) =>
    componentOutletConfigFactory(OfferTitleCellComponent, { inputs: { offer: row } }),
}));
